import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";

import LandingPage from "@/pages/LandingPage";
import EntreprisePage from "@/pages/EntreprisePage";
import CandidatsPage from "@/pages/CandidatsPage";
import AvantagesPage from "@/pages/AvantagesPage";
import OffresPage from "@/pages/OffresPage";
import ContactPage from "@/pages/ContactPage";
import AuthPage from "@/pages/AuthPage";
import CandidateDashboard from "@/pages/CandidateDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import MetierPage from "@/pages/MetierPage";
import ActualitesPage from "@/pages/ActualitesPage";
import MobileApp from "@/mobile/MobileApp";

function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  // Mobile app shell handles its own layout (no Navbar/Footer)
  const isMobileApp = location.pathname === "/app" || location.pathname.startsWith("/app/");

  return (
    <>
      {!isMobileApp && <Navbar />}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/entreprise" element={<EntreprisePage />} />
        <Route path="/candidats" element={<CandidatsPage />} />
        <Route path="/avantages" element={<AvantagesPage />} />
        <Route path="/offres" element={<OffresPage />} />
        <Route path="/metiers/:metier" element={<MetierPage />} />
        <Route path="/metiers/:metier/:ville" element={<MetierPage />} />
        <Route path="/actualites" element={<ActualitesPage />} />
        <Route path="/actualites/:slug" element={<ActualitesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <CandidateDashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin" element={
          <ProtectedRoute requireAdmin>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/app/*" element={<MobileApp />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {!isMobileApp && <Footer />}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
